import type { MapPoint, MapRenderCameraModel } from '../types';

/**
 * Resolves an unrotated camera-label centre from marker position and label offsets.
 *
 * @param camera Immutable camera placement and label settings from the shared render model.
 * @returns New SVG map-coordinate anchor for the independently rendered camera label.
 */
export function resolveCameraLabelAnchor(camera: MapRenderCameraModel): MapPoint {
  return {
    x: camera.positionX + camera.label.offsetX,
    y: camera.positionY + camera.label.offsetY,
  };
}
